import { AppContext } from 'src/components/app-context';
import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'src/reducers';
import { Campaign, LandingPageQuery, Maybe } from 'src/types';
import {
  trackCampaignItemClick,
  trackCampaignLinkClick,
} from '../../areas/campaign/tracking';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from '../../globals/tracking/tracking';
import { ProductsSection } from '../products-section';

type Deal = NonNullable<NonNullable<LandingPageQuery['campaignDeals']>[number]>;

type CampaignDealsProps = {
  deals?: Maybe<Maybe<Deal>[]>;
  campaignLinkQuery?: string;
  negativeMargin?: boolean;
};

const CampaignDeals: React.FC<CampaignDealsProps> = props => {
  const { t } = useContext(AppContext);
  const activeCampaign: Campaign = useSelector((state: AppState) =>
    state.globals.campaigns.active.find((c: Campaign) => c.type === 'OFFER')
  );
  const { deals, campaignLinkQuery } = props;

  if (!deals?.length) {
    return null;
  }

  return (
    <ProductsSection
      title={activeCampaign.name ?? ''}
      linkTitle={t('campaigns', 'link.view-all')}
      linkPath={`${activeCampaign.web_uri?.responsive ??
        ''}${campaignLinkQuery ?? ''}`}
      products={deals
        .filter((d): d is Deal => !!d)
        .map(d => ({ ...d.product, price: d.price }))}
      onHeaderLinkClick={({ link }) => {
        trackCampaignLinkClick(activeCampaign.id, 'deals_component_header');
        trackInternalNavigationClick({
          scope: InternalNavigationScope.CAMPAIGN_HEADER,
          nextPage: link,
        });
      }}
      onProductCardClick={({ index, link }) => {
        const deal = deals[index];
        trackCampaignItemClick(deal);
        trackInternalNavigationClick({
          scope: InternalNavigationScope.CAMPAIGN_PRODUCT_CARD,
          nextPage: link,
          index,
        });
      }}
      dataTestType="campaign-deals"
      negativeMargin={props.negativeMargin}
    />
  );
};

export default memo(CampaignDeals);
